import { Box, Link, Typography } from '@mui/material';
import { t } from 'i18next';
import SbtLogo from '../../../../assets/images/sbt-logo.svg';
import { EXTERNAL_URLS } from '../../../../routing/routes';
import { UrlHelper } from '../../../../common/utils/UrlHelper';

export const SandboxLink = () => {
  return (
    <Box sx={{ py: 1 }}>
      <Typography component="span">{t('reportIsProducedBy')}</Typography>
      <Link href={UrlHelper.wrapExternalDocsUrl(EXTERNAL_URLS.DOCS_HOME)} sx={{ pl: 0.5 }}>
        <SbtLogo height="16" width="16" viewBox="0 -15 60 70" fill="#0D6FA0" />
        <Typography component="span">{t('aqtiveGuardDiscover')}</Typography>
      </Link>
    </Box>
  );
};
